module.exports = __webpack_public_path__ + "assets/img/df850a3c90ad8c36a482724b18349ae2.png";